import { render, staticRenderFns } from "./network-matriz.vue?vue&type=template&id=0e4e04ca&scoped=true"
import script from "./network-matriz.vue?vue&type=script&lang=js"
export * from "./network-matriz.vue?vue&type=script&lang=js"
import style0 from "./network-matriz.vue?vue&type=style&index=0&id=0e4e04ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4e04ca",
  null
  
)

export default component.exports